import { render, staticRenderFns } from "./dialogueM1.vue?vue&type=template&id=b17d4bec&"
import script from "./dialogueM1.vue?vue&type=script&lang=js&"
export * from "./dialogueM1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports